// Backend will return ACTIVE / INACTIVE / SUSPENDED — using uppercase keys
// to match the branch pattern. Adjust when API lands.
export const userStatusConfig = {
  ACTIVE: { label: 'Active', color: '#1fd8a8', bgcolor: 'rgba(31,216,168,0.14)' },
  INACTIVE: { label: 'Inactive', color: '#94a3b8', bgcolor: 'rgba(148,163,184,0.14)' },
  SUSPENDED: { label: 'Suspended', color: '#ff3d57', bgcolor: 'rgba(255,61,87,0.14)' },
}

// `labelKey` is resolved at render via `useLanguage()` so the dropdown
// re-renders without a refresh when the user switches language.
export const userStatusOptions = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' }
]

// Placeholder role/branch lists — wired from API later.
export const roleOptions = [
  'Super Admin',
  'Company Admin',
  'Branch Admin',
  'Facility Manager',
  'Operator',
  'Viewer',
]

export const branchOptions = ['Riyadh HQ', 'Jeddah Branch', 'Dammam Branch', 'Mecca Branch']

// `labelKey` is resolved at render via `useLanguage()` so column headers
// re-render without a refresh when the user switches language.
export const userColumns = [
  { id: 'select', label: '', sortable: false },
  { id: 'name', labelKey: 'Name', sortable: true },
  { id: 'address', labelKey: 'Address', sortable: false },
  { id: 'email', labelKey: 'Email', sortable: true },
  { id: 'phoneNumber', labelKey: 'Phone Number', sortable: true },
  { id: 'status', labelKey: 'Status', sortable: true },
  { id: 'action', label: '', sortable: false },
]

// Static seed rows for design preview — replaced by API later.
export const userSeed = [
  {
    uuid: 'u-001',
    firstName: 'Sarah',
    lastName: 'Al-Otaibi',
    address: 'King Fahd Rd, Riyadh 12211',
    email: 'sarah.otaibi@mdg-guardian.com',
    phoneNumber: '+966 50 112 3344',
    role: 'Company Admin',
    branch: 'Riyadh HQ',
    lastLogin: '2 hours ago',
    status: 'ACTIVE',
  },
  {
    uuid: 'u-002',
    firstName: 'Faisal',
    lastName: 'Al-Mutairi',
    address: 'Prince Sultan St, Jeddah 21589',
    email: 'faisal.mutairi@mdg-guardian.com',
    phoneNumber: '+966 55 889 1122',
    role: 'Branch Admin',
    branch: 'Jeddah Branch',
    lastLogin: 'Yesterday',
    status: 'ACTIVE',
  },
  {
    uuid: 'u-003',
    firstName: 'Mona',
    lastName: 'Al-Ghamdi',
    address: 'Al Faisaliyah, Dammam 32253',
    email: 'mona.ghamdi@mdg-guardian.com',
    phoneNumber: '+966 56 221 9988',
    role: 'Facility Manager',
    branch: 'Dammam Branch',
    lastLogin: '3 days ago',
    status: 'INACTIVE',
  },
  {
    uuid: 'u-004',
    firstName: 'Khalid',
    lastName: 'Al-Harbi',
    address: 'Azizia, Mecca 24243',
    email: 'khalid.harbi@mdg-guardian.com',
    phoneNumber: '+966 11 444 5566',
    role: 'Operator',
    branch: 'Mecca Branch',
    lastLogin: '—',
    status: 'SUSPENDED',
  },
]
